<template>
  <div class="content">
    <div class="detail-drawer">
      <div class="drawer-title" :style="{'line-height': mediaStyle?'' : '53px'}">
        <div class="drawer-title-icon">
          <i class="el-icon-close" @click="handleCloseDrawer" style="cursor:pointer"></i>
        </div>
        <div class="drawer-title-header">
          <div class="drawer-title-text">
            <span class="media-title" :title="mediaForm.mediaName">素材:&nbsp;{{ mediaForm.mediaName }} &nbsp;&nbsp;&nbsp;</span>
            <span :style="{ color: [3, 5].includes(mediaForm.checkStatus) ? 'red' : '#55a532' }" >{{ this.$consts.materialStatisText[mediaForm.checkStatus] }}</span>
            <!-- <el-button class="approv-btn" v-if="mediaForm.checkStatus === 0" size="mini" type="primary" @click="handleSendApprove">送审</el-button> -->
            <!-- <el-button class="retract-btn" v-if="mediaForm.checkStatus === 1" size="mini" type="danger" @click="handleRetract">撤回</el-button> -->
          </div>
          <div v-if="!mediaForm.isMaterialPackage" class="drawer-operate">
            <el-button type="text" icon="el-icon-download" @click="downloadFile(mediaForm.mediaId)" v-permission="'media:download'"></el-button>
          </div>
        </div>
      </div>
      <el-tabs :tab-position="tabPosition" v-model="activeName" style="height: 100%;" class="drawer-tabs" @tab-click="handleTabClick">
        <el-tab-pane name="detail">
          <span slot="label">
            <i class="el-icon-view"></i> 详情
          </span>
          <div class="title-text">基础设置</div>
          <el-form style="width: 100%;" ref="mediaForm" :model="mediaForm" label-width="117px" label-position="left">
            <el-row :gutter="20" style="margin-left: 8px;">
              <el-col :span="10">
                <div style="width: 100%;">
                  <media-view
                    width="100%"
                    height="100%"
                    :mediaClassId="mediaForm.mediaClassId"
                    :src="mediaForm.mediaIconUrl"
                    :previewSrc="mediaForm.mp4Url"
                  ></media-view>
                </div>
              </el-col>
              <el-col :span="12">
                <el-form-item label="广告主">{{ mediaForm.partnerName }}</el-form-item>
                <el-form-item label="广告位">{{ mediaForm.adSpaceName }}</el-form-item>
                <el-form-item label="形式">{{transferMediaType(mediaForm.mediaClassId)}}</el-form-item>
                <el-form-item v-if="mediaForm.duration" label="显示时长">{{ mediaForm.duration }}秒</el-form-item>
                <el-form-item
                  v-if="mediaForm.locationType>=0"
                  label="显示位置"
                >{{$consts.locationTypeText[mediaForm.locationType] }}</el-form-item>
                <el-form-item v-if="mediaForm.locationType===10" label="X轴">{{ mediaForm.coordinateX }}px</el-form-item>
                <el-form-item v-if="mediaForm.locationType===10" label="Y轴">{{ mediaForm.coordinateY }}px</el-form-item>
                <el-form-item v-if="mediaForm.effect" label="动画效果">
                  {{
                  $consts.effectText[mediaForm.effect]
                  }}
                </el-form-item>
                <el-form-item v-if="mediaForm.landingPage" label="落地页">{{ mediaForm.landingPage }}</el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="mediaForm.minIcon">
              <div class="title-text">封面图</div>
              <el-image :src="mediaForm.minIcon" :preview-src-list="[mediaForm.minIcon]" style="margin-left:18px;width: 300px;background-color:#3e649a;"></el-image>
            </el-row>
            <el-row v-if="mediaForm.bgIcon">
              <div class="title-text">背景图</div>
              <el-image :src="mediaForm.bgIcon" :preview-src-list="[mediaForm.bgIcon]" style="margin-left:18px;width: 300px;background-color:#3e649a;"></el-image>
            </el-row>
            <el-row v-if="mediaForm.guideIcon">
              <div class="title-text">弹窗引导图</div>
              <el-image :src="mediaForm.guideIcon" :preview-src-list="[mediaForm.guideIcon]" style="margin-left:18px;width: 300px;"></el-image>
            </el-row>
            <el-row>
              <div class="title-text">媒体方</div>
              <Table
                v-loading="saveMediaLoading"
                :props="cableChannelTable.props"
                :header="cableChannelTable.header"
                :data="mediaForm.mediaCableChannelList"
              />
            </el-row>
            <el-row>
              <div class="title-text">牌照方</div>
              <Table
                v-loading="saveLicenseLoading"
                :props="licenseTable.props"
                :header="licenseTable.header"
                :data="mediaForm.licenseMediaList"
              />
            </el-row>
            <el-row>
              <div class="title-text">素材同步记录</div>
              <Table
                :props="jiaMediaLogTable.props"
                :header="jiaMediaLogTable.header"
                :data="mediaForm.jiaMediaLogList || []"
              />
            </el-row>
            <el-row v-if="showTip && mediaForm.tipsDetail">
              <div class="title-text">广告提示语</div>
              <el-card
                class="content-box"
                shadow="never"
                :body-style="{ padding: 0 }"
                :header="convertTempName(mediaForm.tipsTempId)"
              >
                <AdTipsDetail :tipsDetail="JSON.parse(mediaForm.tipsDetail)" />
              </el-card>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane name="log">
          <span slot="label">
            <i class="el-icon-date"></i> 日志
          </span>
          <ContentBox>
            <Table :props="logTable.props" :header="logTable.header" :data="logTable.data" />
          </ContentBox>
        </el-tab-pane>
      </el-tabs>
      <div></div>
    </div>
  </div>
</template>
<script>
import defaultImg from '@/assets/images/material-default.png'
import AdTipsDetail from '@/components/media/AdTipsDetail.vue'

export default {
  components: {
    AdTipsDetail,
  },
  data() {
    return {
      defaultImg,
      mediaStyle: false,
      showDuration: true,
      mediaClassList: [],
      spaceTempList: [],
      tabPosition: 'left',
      activeName: 'detail',
      dialogTableVisible: false,
      loading: false,
      providerListIndex: {},
      // mediaForm: {},
      pageSize: 10,
      // 当前页码:pageNum
      currentPage: 1,
      totalCount: 1,
      // 查询的页码
      start: 1,
      filter: {},
      logTable: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '操作时间',
            align: 'left',
            prop: 'createTime',
            'show-overflow-tooltip': true
          },
          {
            label: '操作者',
            align: 'left',
            prop: 'operator',
            'show-overflow-tooltip': true,
            formatter: (params) => {
              if (params.userType) {
                return params.userType === 1 ? '管理后台' : params.operator
              } else {
                return '-'
              }
            }
          },
          {
            label: '操作类型',
            align: 'left',
            prop: 'userType',
            'show-overflow-tooltip': true,
            formatter: (params) => {
              if (params.operateType || params.operateType === 0) {
                return this.$consts.operateTypeText[params.operateType]
              } else {
                return '-'
              }
            }
          },
          {
            label: '操作内容',
            align: 'left',
            prop: 'description',
            'show-overflow-tooltip': true
          }
        ],
        data: []
      },
      cableChannelTable: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '媒体方',
            align: 'center',
            prop: 'cableChannelName',
            'show-overflow-tooltip': true
          },
          {
            label: '推送状态',
            align: 'center',
            prop: 'pushStatus',
            'show-overflow-tooltip': true,
            formatter: params => {
              if (params.pushStatus === 0) {
                return '未推送'
              } else if (params.pushStatus === 1) {
                return '已推送'
              } else if (params.pushStatus === 2) {
                return '推送失败'
              } else {
                return '-'
              }
            }
          },
          {
            label: '审核状态',
            align: 'center',
            prop: 'checkStatus',
            'show-overflow-tooltip': true,
            formatter: (params) => {
              if (params.checkStatus === 0) {
                return '待审核'
              } else if (params.checkStatus === 1) {
                return '已审核'
              } else if (params.checkStatus === 2) {
                return '审核不通过'
              } else {
                return '-'
              }
            }
          },
          {
            'render-header': row => {
              return (
                <div>
                  <span>DealId</span>
                  <el-tooltip content="此ID仅与咪咕订单交易时使用" effect="light" placement="top">
                    <i class="el-icon-question grid-tooltip-icon"></i>
                  </el-tooltip>
                </div>
              )
            },
            align: 'center',
            prop: 'dealId',
            'show-overflow-tooltip': true,
          },
          {
            label: '播放串',
            align: 'left',
            prop: 'playCode',
            'show-overflow-tooltip': true,
            formatter: row => {
              return row.playCode ? row.playCode : '-'
            }
          },
          {
            label: '未通过原因',
            align: 'left',
            prop: 'checkRemark',
            'show-overflow-tooltip': true
          },
          {
            label: '操作',
            align: 'center',
            prop: 'operate',
            render: (h, { row }) => {
              return h(
                'el-button',
                {
                  props: { type: 'text', disabled: row.disabled },
                  style: {
                    display: (row.pushStatus === 0 || row.pushStatus === 2) ? 'inline' : 'none'
                  },
                  on: {
                    click: event => {
                      event.stopPropagation()
                      row.disabled = true
                      this.handleCableApprove(row)
                    }
                  }
                },
                '提交审核'
              )
            }
          }
        ],
        data: []
      },
      licenseTable: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '牌照方',
            align: 'center',
            prop: 'licenseName',
            'show-overflow-tooltip': true
          },
          {
            label: '推送状态',
            align: 'center',
            prop: 'pushStatus',
            'show-overflow-tooltip': true,
            formatter: row => {
              return ['未推送', '已推送', '推送失败'][row.pushStatus]
            }
          },
          {
            label: '审核状态',
            align: 'center',
            prop: 'checkStatus',
            'show-overflow-tooltip': true,
            formatter: row => {
              return ['待审核', '审核通过', '已拒绝'][row.checkStatus]
            }
          },
          {
            label: '未通过原因',
            align: 'left',
            prop: 'description',
            'show-overflow-tooltip': true
          },
          {
            label: '补充信息',
            align: 'left',
            prop: 'extraMessage',
            'show-overflow-tooltip': true
          },
          {
            label: '更新时间',
            align: 'left',
            prop: 'updateTime',
            'show-overflow-tooltip': true
          },
          {
            label: '操作',
            align: 'center',
            prop: 'operate',
            render: (h, { row }) => {
              return h(
                'el-button',
                {
                  props: { type: 'text', disabled: row.disabled },
                  style: {
                    display: row.pushStatus === 2 ? 'inline' : 'none'
                  },
                  on: {
                    click: event => {
                      event.stopPropagation()
                      row.disabled = true
                      this.pushLicenseMedia(row)
                    }
                  }
                },
                '提交送审'
              )
            }
          }
        ],
        data: []
      },
      jiaMediaLogTable: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '同步操作',
            align: 'center',
            prop: 'operate',
            'show-overflow-tooltip': true
          },
          {
            label: '状态',
            align: 'center',
            prop: 'status',
            'show-overflow-tooltip': true,
            formatter: row => {
              return ['已推送', '推送失败'][row.status]
            }
          },
          {
            label: '描述',
            align: 'left',
            prop: 'description',
            'show-overflow-tooltip': true
          },
          {
            label: '创建时间',
            align: 'left',
            prop: 'createTime',
            'show-overflow-tooltip': true
          }
        ],
        data: []
      },
      saveMediaLoading: false,
      saveLicenseLoading: false
    }
  },
  props: ['mediaForm', 'tabActiveName', 'showTip'],
  watch: {
    mediaForm: {
      handler() {
        this.setDetailData()
      },
      deep: true
    }
  },
  computed: {},
  methods: {
    convertType(type) {
      let msg = ''
      if (type === 'txt') {
        msg = '文字'
      } else if (type === 'image') {
        msg = '图片'
      } else if (type === 'qrcode') {
        msg = '二维码'
      }
      return msg
    },
    transferMediaType(item) {
      let mediaClassName = ''
      let mediaClass = this.mediaClassList.find((obj) => obj.mediaClassId === item)
      if (mediaClass) {
        mediaClassName = mediaClass.mediaClassName
      }
      return mediaClassName
    },
    convertTempName(tipsTempId) {
      const spaceTemp = this.spaceTempList.find(item => item.tempId === tipsTempId)
      return spaceTemp ? spaceTemp.tempName : '自定义'
    },
    handleTabClick() {},
    handleCloseDrawer() {
      this.$emit('closeDrawer', true)
    },
    handleRefresh() {
      this.currentPage = 1
      this.filter = {}
      this.getMaterialById()
    },
    handleSendApprove() {
      const mediaId = this.mediaForm.mediaId
      if (!mediaId) {
        return
      }
      const params = {
        checkRemark: '送审',
        checkStatus: 1,
        mediaIds: [mediaId]
      }
      this.$service.updateMediaStatus(params).then((res) => {
        if (res.code === 0) {
          this.$emit('reload-content')
          this.$message.success('送审成功')
        }
      })
    },
    handleRetract() {
      const mediaId = this.mediaForm.mediaId
      if (!mediaId) {
        return
      }
      const params = {
        checkRemark: '撤回',
        checkStatus: 0,
        mediaIds: [mediaId]
      }
      this.$service.updateMediaStatus(params).then((res) => {
        if (res.code === 0) {
          this.$emit('reload-content')
          this.$message.success('撤回成功')
        }
      })
    },
    // 每页显示数据量变更, 如每页显示10条变成每页显示20时,val=20
    handleSizeChange: function (val) {
      this.pageSize = val
      this.getMaterialById()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange: function (val) {
      this.currentPage = val
      this.getMaterialById()
    },
    handleScroll(data) {
      let height = document.getElementById(data.label)
      if (height) {
        let total = height.offsetTop
        document.getElementById('rightForm').scrollTo({
          top: total,
          behavior: 'smooth'
        })
      }
    },
    downloadFile(mediaId) {
      this.$service.downLoadImgFile({ mediaId: mediaId }).then((result) => {
        const a = document.createElement('a')
        a.href = result.url
        a.target = '_self'
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      })
    },
    handleCableApprove(row) {
      const param = {
        cableChannelMediaId: row.cableChannelMediaId
      }
      this.saveMediaLoading = true
      this.$service.cableChannelApprove(param).then(res => {
        this.saveMediaLoading = false
        if (res.code === 0) {
          row.disabled = false
          this.$emit('reload-content')
          this.$message.success('提交审核成功')
        }
      }).catch(res => {
        this.saveMediaLoading = false
      })
    },
    pushLicenseMedia(row) {
      this.saveLicenseLoading = true
      this.$service.pushLicenseMedia(row.licenseMediaId).then(res => {
        this.saveLicenseLoading = false
        if (res.code === 0) {
          row.disabled = false
          this.$emit('reload-content')
          this.$message.success('提交送审成功')
        }
      }).catch(res => {
        this.saveLicenseLoading = false
      })
    },
    setDetailData() {
      this.activeName = this.tabActiveName
      this.$service.getAdTempTips({ spaceId: this.mediaForm.spaceId }).then((res) => {
        this.spaceTempList = res || []
      })
      if (this.mediaForm) {
        this.logTable.data = this.mediaForm.mediaLogList
        if (this.mediaForm.mediaName.length > 35) {
          this.mediaStyle = true
        } else {
          this.mediaStyle = false
        }
      }
    }
  },
  created() {
    this.$service.getMediaClass().then((data) => {
      if (data) {
        this.mediaClassList = data
      }
    })
    this.setDetailData()
  }
}
</script>
<style lang="stylus" scoped>
.content
  display flex
  flex-direction column
.detail-drawer
  height inherit
  width 100%
.drawer-title
  display flex
  flex-direction row
  align-items center
  height 53px
  /* line-height: 53px; */
.drawer-title-icon
  width 56px
  text-align center
  height inherit
  background rgba(10, 33, 64, 0.831372549019608)
  color #fff
  height 53px
  line-height 53px
.drawer-title-header
  display flex
  justify-content space-between
  width calc(100% - 56px)
.drawer-title-text
  display flex
  flex-flow row nowrap
  flex 1
  padding 0px 16px
  height inherit
  line-height 36px
  font-size 14px
.drawer-tabs-content
  margin 0 16px
.drawer-title-text-tootip
  white-space nowrap
  display flex
.drawer-operate
  display flex
  align-items center
  justify-content flex-end
  padding-right 20px
.drawer-tabs> >>>.el-tabs__header
  margin 0
  padding 0
  width 55px
  border-bottom none
.drawer-tabs>>>.el-tabs__content
  border-top 1px solid #f0f2f5
  border-left 1px solid #f0f2f5
  height calc(100vh - 60px)
  overflow-y auto
.drawer-tabs> >>>.el-tabs__header .el-tabs__active-bar
  display none
.drawer-tabs> >>>.el-tabs__header .el-tabs__item
  padding 0 !important
  height 53px
.drawer-tabs> >>>.el-tabs__header .el-tabs__item.is-active
  background-color #ff8b00
  color #fff
.drawer-tabs> >>>.el-tabs__header .el-tabs__item :hover
  color rgba(0, 0, 0, 0.65)
.drawer-tabs> >>>.el-tabs__header .el-tabs__item span
  font-size 14px
  display flex
  flex-direction column
  align-items center
  justify-content center
  width 56px
  height 53px
  line-height 2
  font-weight bold
.drawer-tabs>>>.tab-left
  width 100%
  display flex
  height 100%
.drawer-tabs>>>.el-tabs__content .el-tab-pane
  height 100%
  padding 0 16px
.cc-tabs
  width 100%
.cc-tabs>>>.el-tabs__nav-wrap:after
  content none !important
.cc-tabs
  >>>.el-tabs__nav
    width 100%
  >>>.el-tabs__item
    line-height 53px
    width auto !important
    padding 0 20px
    // text-align:left;
  >>>.el-tabs__active-bar
    width 56px !important
.content
  display flex
  flex-direction row
  overflow hidden
  height calc(100vh - 0px)
>>> .el-form-item__label
  color #666
.content-box
  margin-bottom 20px
.box-content-left
  width 400px
.card-box
  display flex
  flex-direction row
.content-right-form
  width calc(100% - 232px)
  overflow auto
  padding 16px
.box
  display flex
  flex-direction column
  border 1px solid #EBEEF5
  color #606266
  border-bottom none
.box-title
  background #EBEEF5
  text-align center
.box-td
  text-align center
  margin auto
  border-right 1px solid #EBEEF5
.box-th
  display flex
  flex-direction row
  border-bottom 1px solid #ebeef5
.el-divider--vertical
  height 100%
  margin 0px 30px
>>>.el-form-item
  margin-bottom 0
  word-break break-all
.box-content-right-img
  margin-right 10px
  border-radius 4px
.demo-rule-form
  maxi-width 500px
.drawer-title-text .el-button
  margin-left 20px
.retract-btn
  margin-top 2px
  height 30px
  line-height 16px
  background-color #d9001b
.media-title
  overflow hidden
  white-space nowrap
  text-overflow ellipsis
  flex 0 0 calc(60% - 260px)
</style>
